import { render, staticRenderFns } from "./WorkflowControlWidget.vue?vue&type=template&id=706e612b&scoped=true&"
import script from "./WorkflowControlWidget.vue?vue&type=script&lang=js&"
export * from "./WorkflowControlWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e612b",
  null
  
)

export default component.exports